export type DocumentSeverity = 'na' | 'low' | 'medium' | 'high'

export type ColorizedDocumentSeverity = 'grey' | 'yellow' | 'red' | 'purple'

export type ColorizedBgDocumentSeverity =
  | '#E00000' // red
  | '#F8E71C' // yellow
  | '#6E6E87' // grey
  | '#1F2C7C' // purple

export type HumanizedDocumentSeverity =
  | 'Unscannable'
  | 'Low risk'
  | 'Medium risk'
  | 'High risk'
  | 'Pending'

export const DocumentSeverityMap = {
  low: {
    label: 'Low risk',
    description: 'These documents contain instances of low severity data.',
    color: {
      label: 'grey',
      value: '#6E6E87'
    }
  },
  medium: {
    label: 'Medium risk',
    description: 'These documents contain instances of medium severity data.',
    color: {
      label: 'yellow',
      value: '#F8E71C'
    }
  },
  high: {
    label: 'High risk',
    description: 'These documents contain instances of high severity data.',
    color: {
      label: 'red',
      value: '#E00000'
    }
  },
  na: {
    label: 'Unscannable',
    description: 'These documents are not scannable due to their file types.',
    color: {
      label: 'purple',
      value: '#1F2C7C'
    }
  },
  default: {
    label: 'Pending',
    description: 'These documents have not been scanned by the risk module.',
    color: {
      label: 'purple',
      value: '#1F2C7C'
    }
  }
} as const

export const humanizedSeverityStatus = (
  severity: DocumentSeverity | null
): HumanizedDocumentSeverity => {
  switch (severity) {
    case 'na':
    case 'low':
    case 'medium':
    case 'high':
      return DocumentSeverityMap[severity].label
    default:
      return DocumentSeverityMap.default.label
  }
}

export const severityStatusColor = (
  severity: DocumentSeverity | null
): ColorizedDocumentSeverity => {
  switch (severity) {
    case 'low':
    case 'medium':
    case 'high':
      return DocumentSeverityMap[severity].color.label
    default:
      return DocumentSeverityMap.default.color.label
  }
}

export const severityStatusBgColor = (
  severity: DocumentSeverity | null
): ColorizedBgDocumentSeverity => {
  switch (severity) {
    case 'low':
    case 'medium':
    case 'high':
      return DocumentSeverityMap[severity].color.value
    default:
      return DocumentSeverityMap.default.color.value
  }
}

export const severityDescription = (
  severity: DocumentSeverity | null
): string => {
  switch (severity) {
    case 'na':
    case 'low':
    case 'medium':
    case 'high':
      return DocumentSeverityMap[severity].description
    default:
      return DocumentSeverityMap.default.description
  }
}
